import React from "react";
import "./Select.css";

const Select = ({ 
  label, 
  name, 
  value, 
  onChange, 
  onBlur,
  options = [], 
  placeholder,
  error,
  disabled,
  required,
  ...props 
}) => {
  
  const handleChange = (e) => {
    if (onChange) onChange(name ? e : e.target.value);
  };

  const handleBlur = (e) => {
    if (onBlur) onBlur(e);
  };

  return (
    <div className="form-group">
      {label && (
        <label htmlFor={name}>
          {/* P2 — marquage obligatoire UNIFIÉ (même règle que Input) : un seul astérisque stylé. */}
          {typeof label === 'string' ? label.replace(/\s*\*\s*$/, '') : label}
          {(required || (typeof label === 'string' && /\*\s*$/.test(label))) && <span className="required"> *</span>}
        </label>
      )}

      <select
        id={name}
        name={name}
        value={value || ""}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={disabled}
        className={`form-select ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={error && name ? `${name}-error` : undefined}
        {...props}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {/* 🛡️ Robustesse : on ignore toute option null/undefined ou sans `value` (sinon
            option.value plantait le rendu → « Cannot read properties of undefined (reading 'value') »
            → écran blanc de tout l'écran admin). Les chaînes sont aussi tolérées. */}
        {(Array.isArray(options) ? options : [])
          .filter((o) => o != null)
          .map((option, i) => {
            const val = typeof option === 'object' ? option.value : option;
            const lab = typeof option === 'object' ? option.label : option;
            return (
              <option key={`${val ?? 'opt'}-${i}`} value={val ?? ''} disabled={typeof option === 'object' ? option.disabled : false}>
                {lab}
              </option>
            );
          })}
      </select>

      {error && <div className="error-message" id={name ? `${name}-error` : undefined} role="alert">{error}</div>}
    </div>
  );
};

export default Select;
